// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scroll[data-v-08b46200]{display:flex!important;flex-direction:column}.overflow[data-v-08b46200]{flex-grow:1;overflow:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
